import { Template } from "../../../../sdkStructs";

export interface TemplateHashes {
  templateId: number;
  pentestId: number | string;
  vulnsHash: string;
  appendixHash: string;
  templateHash: string;
}

// Helper function to calculate a simple hash of objects for comparison
export const calculateHash = (obj: unknown): string => {
  if (!obj) return "";
  if (Array.isArray(obj)) {
    return JSON.stringify(obj.map((item) => item.UpdatedAt));
  }
  return JSON.stringify((obj as { UpdatedAt: unknown }).UpdatedAt);
};

// Calculate a hash for the template content that affects PDF generation
export const calculateTemplateHash = (template: Template): string => {
  if (!template) return "";

  // // Include the important template fields that affect PDF generation
  // const relevantFields = {
  //   PageOrder: template.PageOrder || [],
  //   TemplateName: template.TemplateName,
  //   PrimaryColor: template.PrimaryColor,
  //   SecondaryColor: template.SecondaryColor,
  //   BackgroundColor: template.BackgroundColor,
  //   TextFont: template.TextFont,
  //   TitleFont: template.TitleFont,
  //   TextFontSize: template.TextFontSize,
  //   TitleFontSize: template.TitleFontSize,
  //   Motto: template.Motto,
  //   Logo: template.Logo,
  //   ChartType: template.ChartType,
  //   FooterText: template.FooterText,
  //   LogoPosition: template.LogoPosition,
  //   MottoPosition: template.MottoPosition,
  //   PageNumberPosition: template.PageNumberPosition,
  //   ContactInformation: template.ContactInformation,
  //
  //   ExecutiveSummary: template.ExecutiveSummary,
  //   DocxPath: template.DocxPath ?? "",
  // };

  return JSON.stringify(template); // TODO: check if can use just template for hashes
};

export const areEqualHashes = (last: TemplateHashes, current: TemplateHashes): boolean => {
  // console.log("Comparing hashes:", {
  //   templateChanged: last.templateHash !== current.templateHash,
  //   pentestChanged: last.pentestId !== current.pentestId,
  //   vulnsChanged: last.vulnsHash !== current.vulnsHash,
  //   appendixChanged: last.appendixHash !== current.appendixHash,
  // });

  return (
    last.templateId === current.templateId &&
    last.pentestId === current.pentestId &&
    last.vulnsHash === current.vulnsHash &&
    last.appendixHash === current.appendixHash &&
    last.templateHash === current.templateHash
  );
};
